import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'jernygateway';

class EntityService extends ServiceBase {
    /**
     * returns entity card data
     * @param {string} rk - device / battery name, should be set prevent using all
     * @returns {Promise}
     */
    getEntityCard = (rk) => {
        const url = `${baseUrl}/${service}/entity/cards?rk=${rk}`;
        const cfg = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, cfg);
    };
}

const entityService = new EntityService();
export default entityService;
